import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TripCSVExportData} from '../models/tripCSVExportData';



@Injectable({
  providedIn: 'root'
})
export class AnalysisInformationService {

  constructor(
      private http: HttpClient,
      @Inject('TimeZoneFactory') private timeZoneFactory: any,
  ) {
  }


  getCSVMessages = (url: string): Observable<TripCSVExportData> => {
    return this.http.get<TripCSVExportData>(url);
  }
}
